module.exports = __webpack_public_path__ + "static/media/2019_4G8A5305.fdf18246.jpg";